import { render, staticRenderFns } from "./formDeleteDriver.vue?vue&type=template&id=089d20c0&scoped=true"
import script from "./formDeleteDriver.vue?vue&type=script&lang=js"
export * from "./formDeleteDriver.vue?vue&type=script&lang=js"
import style0 from "./formDeleteDriver.vue?vue&type=style&index=0&id=089d20c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089d20c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('089d20c0')) {
      api.createRecord('089d20c0', component.options)
    } else {
      api.reload('089d20c0', component.options)
    }
    module.hot.accept("./formDeleteDriver.vue?vue&type=template&id=089d20c0&scoped=true", function () {
      api.rerender('089d20c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transport/driver/components/form/formDeleteDriver.vue"
export default component.exports